import { request } from './client.js';
export const authApi = {
    login(input) {
        return request('/auth/login', {
            method: 'POST',
            body: input,
            refreshOn401: false,
        });
    },
    activate(input) {
        return request('/auth/activate-invitation', {
            method: 'POST',
            body: input,
            refreshOn401: false,
        });
    },
    refresh(input, opts) {
        return request('/auth/refresh', {
            method: 'POST',
            body: input,
            refreshOn401: false,
            signal: opts?.signal,
        });
    },
    logout(input) {
        return request('/auth/logout', {
            method: 'POST',
            body: input,
            refreshOn401: false,
        });
    },
    requestPasswordReset(email) {
        return request('/auth/request-password-reset', {
            method: 'POST',
            body: { email },
            refreshOn401: false,
        });
    },
    resetPassword(input) {
        return request('/auth/reset-password', {
            method: 'POST',
            body: input,
            refreshOn401: false,
        });
    },
    setupMfa(input) {
        return request('/auth/mfa/setup', {
            method: 'POST',
            body: input,
            refreshOn401: false,
        });
    },
    activateMfa(input) {
        return request('/auth/mfa/activate', {
            method: 'POST',
            body: input,
            refreshOn401: false,
        });
    },
    verifyMfa(input) {
        return request('/auth/mfa/verify', {
            method: 'POST',
            body: input,
            refreshOn401: false,
        });
    },
    // Email OTP — alternative second factor (email-otp-2fa). Lets a user who
    // skipped TOTP enrollment (or has it enabled) verify via a 6-digit code
    // emailed to them instead of an authenticator-app code.
    requestMfaEmailOtp(input) {
        return request('/auth/mfa/email/request', {
            method: 'POST',
            body: input,
            refreshOn401: false,
        });
    },
    verifyMfaEmailOtp(input) {
        return request('/auth/mfa/email/verify', {
            method: 'POST',
            body: input,
            refreshOn401: false,
        });
    },
};
//# sourceMappingURL=auth.js.map